import { AxiosResponse } from 'axios';
import { INVENTORY_SERVICE_URL } from '../../../../config';
import { PaginatedSuppliers } from '../../../../interfaces/suppliers/paginatedStore.type';
import inventoryAxios from '../../../../utils/axios/inventory.axios';

const tryToFetchPurchases = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<PaginatedSuppliers>> => {
    const url = `${INVENTORY_SERVICE_URL}/hotel-purchase-orders/all?page=${pageNumber}&size=${pageSize}`;
    return inventoryAxios.put<PaginatedSuppliers>(url, data)
}

const tryToCreatePurchase = (data: any): Promise<AxiosResponse> => {
    return inventoryAxios.post(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders`, data);
};

const tryToEditPurchase = (id: string, data: any): Promise<AxiosResponse> => {
    return inventoryAxios.put(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}/edit`, data);
};

const tryToFetchSinglePurchase = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.get(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}`)
};

const tryToFetchPurchaseMismatch = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.get(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}/invoice-details`)
};

const tryToDownloadPurchaseDetails = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.get(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}/download`)
};

const tryToDeletePurchase = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.delete(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}`);
};

export const PurchasesService = {
    tryToFetchPurchases,
    tryToFetchPurchaseMismatch,
    tryToCreatePurchase,
    tryToEditPurchase,
    tryToDownloadPurchaseDetails,
    tryToFetchSinglePurchase,
    tryToDeletePurchase
}